module.exports = __webpack_public_path__ + "img/CP.94dc90e2.svg";